import { forwardRef } from 'react';

import { cn } from '@/shared/utils/cn';

const variants = {
  primary: 'bg-brand-600 text-white hover:bg-brand-700 disabled:bg-brand-600',
  secondary:
    'border bg-[var(--app-surface)] text-[var(--app-fg)] hover:bg-black/5 dark:hover:bg-white/5',
  ghost: 'text-[var(--app-fg)] hover:bg-black/5 dark:hover:bg-white/5',
  // Storefront: gold pill CTA — white text on gold, soft lift on hover.
  gold: 'bg-gold-500 text-white shadow-[var(--shadow-soft)] hover:bg-gold-600 hover:-translate-y-0.5 disabled:bg-gold-500',
  // Storefront: outline secondary — gold hairline + gold text, fills on hover.
  outline:
    'border border-gold-500 bg-transparent text-gold-700 hover:bg-gold-500 hover:text-white',
};

export const Button = forwardRef(function Button(
  {
    children,
    className,
    variant = 'primary',
    loading = false,
    disabled,
    type = 'button',
    ...props
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex min-h-10 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60',
        variants[variant],
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && (
        <span
          aria-hidden="true"
          className="size-4 animate-spin rounded-full border-2 border-current border-r-transparent"
        />
      )}
      {children}
    </button>
  );
});
